enum DeferredState {
	Pending,
	Locked,
	Rejected,
	Resolved
}

export class Deferred<T = any> implements PromiseLike<T> {
	private _promise: Promise<T>;
	private _resolve: (value?: T) => void;
	private _reject: (reason?: any) => void;
	private state = DeferredState.Pending;

	constructor() {
		this._promise = new Promise<T>((resolve, reject) => {
			this._resolve = resolve;
			this._reject = reject;
		});
	}

	get promise() {
		return this._promise;
	}

	get locked() {
		return this.state === DeferredState.Locked;
	}

	get pending() {
		return this.state === DeferredState.Pending;
	}

	lock(): Deferred<T> {
		this.state = DeferredState.Locked;

		const wrapper = new Deferred<T>();
		wrapper._promise = this._promise;
		wrapper._resolve = this._resolve;
		wrapper._reject = this.reject;
		return wrapper;
	}

	resolve(value?: T) {
		if (this.pending) {
			this.state = DeferredState.Resolved;
			this._resolve(value);
		}
	}

	reject(reason?: any) {
		if (this.pending) {
			this.state = DeferredState.Rejected;
			this._reject(reason);
		}
	}

	then<TResult1 = T, TResult2 = never>(onfulfilled?: (value: T) => TResult1 | PromiseLike<TResult1>, onrejected?: (reason: any) => TResult2 | PromiseLike<TResult2>): PromiseLike<TResult1 | TResult2> {
		return this.promise.then(onfulfilled, onrejected);
	}
}